<template>
  <div class="pa-4 pt-2">
    <v-tabs
      v-model="tab"
      style="box-shadow: none !important"
      height="35"
      slider-size="1.5"
      show-arrows
    >
      <v-tabs-slider color="warning"></v-tabs-slider>
      <v-tab
        v-for="(item, index) in masterTab"
        :key="item"
        :data-cy="item"
        class="text-xs font-weight-semibold"
        :class="[tab === index ? 'dark--text' : 'accent--text']"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-divider class=""></v-divider>
    <!-- reset v-window vuetify class with that unable to position sticky -->
    <v-tabs-items v-model="tab" class="pt-3" style="overflow: inherit">
      <v-tab-item v-for="item in masterTab" :key="item">
        <v-card v-if="item === 'Activity'" flat class="tab-card">
          <div class="custom-tab">
            <v-tabs
              v-model="activityTab"
              class="estimation-tabs"
              hide-slider
              height="40"
              style="box-shadow: none !important"
            >
              <v-tab
                v-for="(data, index) in ['New Task']"
                :key="index"
                :data-cy="data"
                hide-slider
                class="activity-header-tab text--primary text-2xs font-weight-semibold"
              >
                {{ data }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="activityTab" class="tab-item-body">
              <v-tab-item v-for="data in ['New Task']" :key="data">
                <v-card-text v-if="data === 'New Task'" class="pa-4">
                  <TaskAddForm
                    :prop-id="$route.params.project_id"
                    prop-type="fieldProject"
                    module="field management"
                    @fetchData="fetchData"
                  />
                </v-card-text>
                <!-- <v-card-text v-if="data === 'Log a Call'" class="pa-4">
                  <log-call-form
                    :prop-id="$route.params.project_id"
                    prop-type="fieldProject"
                    :contact-array="contactArray"
                    @fetchData="fetchLogData"
                  ></log-call-form>
                </v-card-text> -->
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div class="mt-4 text-sm">
            <upcoming-task
              ref="upcomingtaskComponent"
              prop-type="fieldProject"
              :prop-id="$route.params.project_id"
              @taskFetch="fetchLogData"
            ></upcoming-task>
            <div v-intersect="infiniteScrollTask"></div>
            <call-logs
              ref="logsComponent"
              class="mt-3"
              prop-type="fieldProject"
              :prop-id="$route.params.project_id"
              :contact-array="contactArray"
              @taskFetch="fetchData"
            ></call-logs>
            <div v-intersect="infiniteScrollLogs"></div>
          </div>
        </v-card>
        <div v-if="item === 'Engage'">
          <v-card flat class="tab-card">
            <v-card-text class="pa-4">
              <ChatterPost
                ref="chatterPost"
                prop-type="fieldProject"
                :prop-id="$route.params.project_id"
                :comment-form="commentForm"
                @fetchData="fetchCommets"
                @commentEvent="commentEvent"
              />
            </v-card-text>
          </v-card>
          <comment-list
            v-for="(comment, i) in commentList"
            :key="comment.uuid"
            :index="i"
            :prop-id="$route.params.project_id"
            :comment="comment"
            prop-type="fieldProject"
            @fetchData="fetchCommets"
          ></comment-list>
        </div>
        <div v-if="item === 'Email'" class="tab-card">
          <div class="custom-tab">
            <v-tabs
              v-model="emailTab"
              class="estimation-tabs"
              hide-slider
              height="40"
              style="box-shadow: none !important"
            >
              <v-tab
                v-for="(data, index) in ['New Email', 'Inbox Mail']"
                :key="index"
                hide-slider
                class="activity-header-tab text--primary text-2xs font-weight-semibold"
              >
                {{ data }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="emailTab" class="tab-item-body">
              <v-tab-item>
                <compose-email
                  prop-type="fieldProject"
                  :prop-id="getPropId"
                  :contact-array="contactArray"
                  @fetchRecord="fetchEmailLog"
                ></compose-email>
              </v-tab-item>
              <v-tab-item>
                <EmailList ref="emailLogsComponent" prop-type="fieldProject" :prop-id="getPropId" />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import schema from '@/schema/crmSchema'
import { useRouter } from '@core/utils'
import Toaster from '@core/utils/sweetToast'
import TaskAddForm from '@/components/shared-components/TaskAddForm.vue'
import LogCallForm from '@/components/crm/account/tabs/activity-child-tab/LogCallForm.vue'
import UpcomingTask from '@/components/crm/components/UpcomingTask.vue'
import ChatterPost from '@/components/crm/components/ChatterPost.vue'
import CallLogs from '@/components/crm/components/CallLogs.vue'
import CommentList from '@/components/crm/components/CommentList.vue'
import ComposeEmail from '@/components/crm/components/ComposeEmail.vue'
import EmailList from '@/components/crm/components/EmailList.vue'

export default {
  components: {
    LogCallForm,
    UpcomingTask,
    CallLogs,
    ChatterPost,
    CommentList,
    ComposeEmail,
    EmailList,
    TaskAddForm,
  },
  props: {
    contactArray: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, ctx) {
    const { GET_ALL_RECORDS } = storeActions

    const masterTab = ['Activity', 'Engage', 'Email']
    const tab = ref(null)
    const activityTab = ref(null)
    const emailTab = ref(null)
    const newsTab = ref(null)
    const upcomingtaskComponent = ref(null)
    const logsComponent = ref(null)
    const emailLogsComponent = ref(null)
    const commentList = ref([])
    const chatterPost = ref(null)
    const { route } = useRouter()
    const commentForm = ref({
      attachments: [],
      comment: null,
      loading: false,
    })

    const getPropId = computed(() => {
      return route.value.params.project_id
    })

    const fetchCommets = () => {
      const payload = {
        component: 'setup/comments/list',
        object: {
          prop_id: route.value.params.project_id,
          prop_type: 'fieldProject',
          uuid: route.value.query.chatterId,
        },
      }
      store.dispatch(`common/${storeActions.CREATE}`, payload).then(({ data }) => {
        if (data.success) {
          commentList.value = data.data
        } else {
          commentList.value = []
        }
      })
    }

    const fetchContactArray = () => {
      const payload = {
        component: 'crm/contacts/mappings/list',
        object: {
          prop_type: 'projects',
          prop_id: route.value.params.projectId,
        },
        filter: {
          limit: -1,
        },
      }
      fetchApiPost(payload)
    }

    const commentEvent = resetEditor => {
      commentForm.value.loading = true
      const pattern =
        /"[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gm // for detect uuids
      let mentionIds = commentForm.value.comment.match(pattern)
      if (mentionIds) {
        mentionIds = mentionIds.map(opt => {
          return opt.substring(1)
        })
      }

      const attachmentPattern =
        /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gm // for detect uuids
      let attachIds = commentForm.value.comment.match(attachmentPattern)
      if (attachIds) {
        attachIds = attachIds.map(opt => {
          return opt.substring(1)
        })
      }

      const payLoad = {
        object: {
          prop_id: route.value.params.project_id,
          prop_type: 'fieldProject',
          tagged_users: mentionIds || [],
          attachments: attachIds || [],
          comment: commentForm.value.comment,
        },
        component: 'setup/comments',
      }
      store
        .dispatch(`common/${storeActions.CREATE}`, payLoad)
        .then(({ data }) => {
          commentForm.value.loading = false
          if (data.success) {
            commentForm.value = {
              loading: false,
              comment: null,
              attachments: [],
            }
            fetchCommets()
            Toaster.success(data.message)
            resetEditor()
          } else {
            Toaster.error(data.message, 'warning')
          }
        })
        .catch(err => {
          commentForm.value.loading = false
          if (err?.response.status === 403) {
            Toaster.error(err.response.data.message)
          } else {
            Toaster.error()
          }
        })
    }

    watch(
      () => ctx.root.$route.query,
      () => {
        // open chatter tab if chatter query params is true
        if (route.value.query.chatter === 'true') {
          tab.value = 1
        }
      },
      { immediate: true },
    )

    const fetchData = () => {
      upcomingtaskComponent.value[0].loadMore()
      logsComponent.value[0].loadMore()
      logsComponent.value[0].loadTasks()
    }

    const fetchLogData = () => {
      logsComponent.value[0].loadMore()
      logsComponent.value[0].loadTasks()
    }

    const fetchEmailLog = () => {
      if (emailLogsComponent.value) {
        emailLogsComponent.value[0]?.loadMore()
      }
    }

    watch(
      () => ctx.root.$route,
      () => {
        fetchCommets()
      },
      { immediate: true },
    )

    const infiniteScrollTask = (entries, observer, isIntersecting) => {
      if (!isIntersecting) return
      upcomingtaskComponent.value[0].infiniteScroll()
    }
    const infiniteScrollLogs = (entries, observer, isIntersecting) => {
      if (!isIntersecting) return
      logsComponent.value[0].infiniteScrolling()
    }

    return {
      tab,
      masterTab,
      activityTab,
      emailTab,
      upcomingtaskComponent,
      logsComponent,
      emailLogsComponent,
      newsTab,
      fetchData,
      fetchLogData,
      infiniteScrollTask,
      infiniteScrollLogs,
      fetchEmailLog,
      commentList,
      fetchCommets,
      commentForm,
      commentEvent,
      chatterPost,
      getPropId,
    }
  },
}
</script>
